import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=385d8f31&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=385d8f31&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385d8f31",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('385d8f31')) {
      api.createRecord('385d8f31', component.options)
    } else {
      api.reload('385d8f31', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=385d8f31&scoped=true&", function () {
      api.rerender('385d8f31', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ogyq2c6sYiCu/JS/comp/PopupDialog.vue"
export default component.exports